<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          保洁推荐
          <span style="color:red;">（鲸致保洁师推荐标准：年龄18-48周岁（以身份证年龄为准）、识字、会骑自行车/电动车）</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <!-- 
                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" style="width:150px" clearable placeholder="请选择城市" filterable>
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
                    </el-select>
        </el-form-item>-->

        <el-form-item label="联系电话">
          <el-input
            v-model="listQuery.tel"
            type="number"
            style="width:180px"
            placeholder="请输入联系电话"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="服务者姓名">
          <el-input
            v-model="listQuery.workerName"
            style="width:150px"
            placeholder="请输入服务者姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="入职状态">
          <el-select v-model="listQuery.joinState" clearable placeholder="请选择" filterable>
            <el-option label="未入职" value="未入职"></el-option>
            <el-option label="已上线" value="已上线"></el-option>
            <el-option label="已解约" value="已解约"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务者类型">
          <el-select v-model="listQuery.workerType" clearable placeholder="请选择" filterable>
            <el-option label="保洁" value="保洁"></el-option>
            <el-option label="保姆" value="保姆"></el-option>
            <el-option label="品类" value="品类"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="线索状态">
          <el-select v-model="listQuery.clueState" clearable placeholder="请选择" filterable>
            <el-option v-for="(item,index) in clueState" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
          <el-button icon="el-icon-plus" type="primary" plan @click="handleCreate">推荐保洁师</el-button>
          <el-button type="success" icon="el-icon-download" @click="downloadWorker">导出</el-button> 
        </el-form-item>
        <el-form-item label="切换门店">
          <el-select  placeholder="切换门店" style="margin-right:10px;" v-model="companyStoreid" @change="changeStoreId" class="campanyStore">
                        <el-option  v-for="item in companyStoreList" :key="item.id" :label="item.franchiseeName" :value="item.id"></el-option>
                    </el-select>
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column prop="clueNo" label="线索编号" width="150"></el-table-column>
        <el-table-column prop="workerNo" label="服务者编号" width="100"></el-table-column>
        <el-table-column prop="workerName" label="姓名" width="70"></el-table-column>
        <el-table-column prop="cityName" label="城市" width="70"></el-table-column>
        <el-table-column prop="idCard" label="身份证" width="150"></el-table-column>
        <el-table-column prop="tel" label="联系电话" width="100">
          <template slot-scope="scope">
            <phoneTag :phone="scope.row.tel" />
          </template>
        </el-table-column>
        <el-table-column prop="clueState" label="线索状态"></el-table-column>
        <el-table-column prop="laiyuan" label="来源"></el-table-column>
        <el-table-column prop="guishu" label="归属"></el-table-column>
        <el-table-column prop="workerType" label="类型"></el-table-column>
        <el-table-column prop="joinState" label="入职状态"></el-table-column>
        <el-table-column prop="joinDays" label="入职天数"></el-table-column>
        <el-table-column prop="recommendTime" label="推荐时间"></el-table-column>
        <el-table-column prop="followTIme" label="跟进时间"></el-table-column>
        <el-table-column prop="firstBookTime" label="首次做单时间"></el-table-column>
        <el-table-column prop="fiveDayBookNumber" label="近5天做单量"></el-table-column>
        <el-table-column prop="bookAllNumber" label="累计单量"></el-table-column>
        <!-- <el-table-column prop="joinDemand" label="求职意向">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state==3?'success':''">{{getqzyx(scope.row.joinDemand)}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="线索状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state==3?'success':''">{{clueState[scope.row.state]}}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="sourceRelationName" label="线索来源"></el-table-column>
        <el-table-column prop="workerBelongName" label="服务者归属"></el-table-column>-->
        <!-- <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column> -->
      </el-table>

      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />
    </el-card>

    <!--新增线索 -->
    <workerClueAddFormNew ref="workerClueAddFormNewRef" />
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import workercrmapi from "@/script/api/workercrmapi";
import clueDetail from "@/components/workercrm/clueDetail.vue";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";
import phoneTag from "@/components/workercrm/compent/phoneTag.vue";
import url from "@/script/baseUrl.js";

import ajaxAuth from "@/script/api/auth.js";

import workerClueAddFormNew from "@/components/workercrm/compent/workerClueAddFormNew.vue";
import { validateIdNo } from "@/script/validator";
let vm;
export default {
  components: {
    Pagination,
    clueDetail,
    phoneTag,
    workerClueAddFormNew
  },
  filters: {
    filterWorkerType(type) {
      if (type == 1) return "保洁";
      if (type == 2) return "保姆";
      if (type == 3) return "品类";
    }
  },
  data() {
    return {
      companyStoreList: [],
      companyStoreid: null,
      exportWorkerUrl:
        url.salaryUrl +
        "/workerClue/selectHHRPerson?token=" +
        window.localStorage.getItem("token"),
      sourceName: { 1: "渠道", 2: "合伙⼈", 3: "公司BD", 4: "转介绍" },
      // clueState: {
      //     1: "待分配",
      //     2: "跟进中",
      //     3: "跟进成功",
      //     4: "跟进失败",
      //     5: "上线失败",
      //     6: "跟单失败",
      //     7: "培训失败",
      //     8: "上线成功",
      // },
      clueState: [
        "待分配",
        "跟进中",
        "跟进成功",
        "跟进失败",
        "上线失败",
        "跟单失败",
        "培训失败",
        "上线失败"
      ],
      workTypes: [
        { value: 1, label: "保洁" },
        { value: 2, label: "保姆" },
        { value: 3, label: "品类" }
      ],
      skillGroups: [],
      supplierList: [],
      listData: [],
      cityList: [],
      sysUserList: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        tel: "",
        workerName: "",
        joinState: "",
        workerType: "",
        clueState: ""
      },

      upgradeForm: {
        clueId: "",
        comment: "",
        skillGroupId: "",
        userId: ""
      },
      rules_Upgrade: {
        comment: [
          {
            required: true,
            message: "请输入跟进内容",
            trigger: "change"
          }
        ],
        userId: [
          {
            required: true,
            message: "请选择流转人",
            trigger: "change"
          }
        ]
      },
      showClueDetailForm: false,
      clueDetailForm: {
        ticketId: "",
        clueId: ""
      },
      showFollowForm: false
    };
  },

  created() {
    this.getAllCity();
    this.getSupplierList();
    this.querySearch();
    
    let that = this;
    setTimeout(function () {
        that.findoneuserFun();
    }, 450);
   
  },
  methods: {
    findoneuserFun() {
            this.companyStoreList = JSON.parse(
                window.localStorage.getItem("franchiseeList")
            );
            this.companyStoreid = JSON.parse(
                window.localStorage.getItem("franchiseeChoose")
            ).id;
           
        },
    changeStoreId(val) {
            let temp = {
                companyId: JSON.parse(window.localStorage.getItem("company"))
                    .id,
                franchiseeId: val,
                userId: JSON.parse(window.localStorage.getItem("userInfo")).id,
            };
            ajaxAuth.$ajaxUpdateDefaultFranchisee(temp)
                .then((res) => {
                    if (res.data.errno == 0) {
                        globalData.initUserAuth(this);
                        const loading = this.$loading({
                            lock: true,
                            text: "努力加载中...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.7)",
                        });
                        setTimeout(() => {
                            window.location.reload();
                        }, 1500);
                        setTimeout(() => {
                            this.$message.success("切换门店成功！");
                            loading.close();
                        }, 1000);
                    } else {
                        this.$message.warning(res.data.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    handleCreate() {
      this.$refs.workerClueAddFormNewRef.showAddWorkerClue(1, 1);
    },
    handleFollow(row) {
      //跟进
      this.showFollowForm = true;
      this.followForm = {
        clueId: row.id,
        comment: "",
        operId: globalData.userInfo.id,
        operName: globalData.userInfo.userName,
        ticketId: row.ticket.id
      };
    },
    saveFollow() {
      this.$refs["followForm"].validate(valid => {
        if (valid) {
          workercrmapi.$axiosGetTicketRemark(this.followForm).then(res => {
            this.$message.success("操作成功");
            this.showFollowForm = false;
          });
        }
      });
    },
    //查询
    querySearch() {
      this.listQuery.pageSize = this.pageSize;
      this.listQuery.pageNum = this.currentPage;
      this.listQuery.sourceRelationId = globalData.franchisee.id;
      this.listQuery.sourceType = "1,2"; //1渠道，2合伙人 （2合伙人兼容老版本）
      workercrmapi.$axiosGetClueListNew(this.listQuery).then(res => {
        if (res.data.errno == 0) {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        }
      });
    },
    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity({ userId: globalData.userInfo.id }).then(res => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },

    getSkillGroup() {
      //获取技能组
      workercrmapi.$axiosGetSkillGroup().then(res => {
        let skills = [];
        if (res.data.errno == 0 && res.data.data.length > 0) {
          res.data.data.forEach(item => {
            item.userList.forEach(user => {
              user.name = user.userName;
            });
            skills.push(item);
          });
        }
        this.skillGroups = skills;
      });
    },
    getSupplierList() {
      //获取归属
      workercrmapi
        .$axiosGetSupplierList({ companyId: globalData.company.id })
        .then(res => {
          this.supplierList = res.data.data;
        });
    },
    getSysUser() {
      //城市下拉框
      service.$axiosSysUsergetallUser().then(res => {
        if (res.data.errno == 0) {
          this.sysUserList = res.data.data;
        }
      });
    },
    getqzyx(val) {
      if (val == null || val == "") {
        return;
      }
      //1保洁、2保姆、3品类
      return val
        .replace("1", "保洁")
        .replace("2", "保姆")
        .replace("3", "品类");
    },

    downloadWorker() {
let sourceRelationId = globalData.franchisee.id;
      let params = `&pageSize=${this.pageSize}&pageNum=${this.currentPage}&tel=${this.listQuery.tel}&workerName=${this.listQuery.workerName}&joinState=${this.listQuery.joinState}&workerType=${this.listQuery.workerType}&clueState=${this.listQuery.clueState}&export=1&sourceRelationId=${sourceRelationId}`;
      window.open(this.exportWorkerUrl + params);
    }
  },
  beforeCreate() {
    vm = this;
  }
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
</style>